import React, { FC, MouseEvent } from "react";
import styled from "styled-components";

import { XIcon } from "@adsk/alloy-react-icon";

import { statusColors, StatusItem } from "../models/statusSets";
import { StatusLabel } from "./commonStyledComponents";

const StatusValueTagContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const IconWithMargin = styled(XIcon)`
  margin-left: 8px;
  margin-right: 6px;
`;

const StatusValueTag: FC<
  StatusItem & {
    className?: string;
    onRemove: (statusId: StatusItem["value"]) => void;
  }
> = ({ className, onRemove, color, label, value }) => (
  <StatusValueTagContainer className={className}>
    <StatusLabel color={color && statusColors[color]}>{label}</StatusLabel>
    <IconWithMargin
      size={14}
      onClick={(e: MouseEvent<SVGSVGElement>) => {
        e.preventDefault();
        e.stopPropagation();
        onRemove(value);
      }}
    />
  </StatusValueTagContainer>
);

export default StatusValueTag;
